import { render, staticRenderFns } from "./h5Pay.vue?vue&type=template&id=a12af960&scoped=true&"
import script from "./h5Pay.vue?vue&type=script&lang=ts&"
export * from "./h5Pay.vue?vue&type=script&lang=ts&"
import style0 from "./h5Pay.vue?vue&type=style&index=0&id=a12af960&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12af960",
  null
  
)

export default component.exports